import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { RATINGS_COLORS } from '../common/utils'

export function SensorialScale(): JSX.Element {
    return (
        <StyledSensolrialScale className="sensorialScale--sensorialScale">
            <div className="sensorialScale--acceptable">{i18n('acceptable')}</div>
            <div className="sensorialScale--takeAction">{i18n('take action')}</div>
            <div className="sensorialScale--refuse">{i18n('retain and refuse')}</div>
            <div className="sensorialScale--excelent">0 | {i18n('excelent')}</div>
            <div className="sensorialScale--good">1 | {i18n('good')}</div>
            <div className="sensorialScale--regular">2 | {i18n('regular')}</div>
            <div className="sensorialScale--bad">3 | {i18n('bad')}</div>
            <div className="sensorialScale--critical">4 | {i18n('critical')}</div>
            <div className="sensorialScale--reason">{i18n('reason')}</div>
            <div className="sensorialScale--definition">{i18n('definition')}</div>
            <div className="sensorialScale--excelent__reason">{i18n('Igual ao desenho')}</div>
            <div className="sensorialScale--good__reason">{i18n('Ligeiramente diferente do desenho')}</div>
            <div className="sensorialScale--regular__reason">{i18n('Algum atributo diferente do desenho')}</div>
            <div className="sensorialScale--bad__reason">{i18n('Diferente do desenho')}</div>
            <div className="sensorialScale--critical__reason">{i18n('Totalmente diferente do desenho')}</div>
            <div className="sensorialScale--excelent__definition">{i18n('Produto de preferência do consumidor')}</div>
            <div className="sensorialScale--good__definition">
                {i18n('O painel observa ligeiras diferenças, porém imperceptíveis ao consumidor')}
            </div>
            <div className="sensorialScale--regular__definition">
                {i18n('O painel observa diferença e o consumidor pode perceber e mudar sua preferência')}
            </div>
            <div className="sensorialScale--bad__definition">
                {i18n('O consumidor pode não comprear o produto ou reclamar caso compre')}
            </div>
            <div className="sensorialScale--critical__definition">
                {i18n('Ocasionará reclamação de consumidor ou provável desistência de compra')}
            </div>
        </StyledSensolrialScale>
    )
}

const StyledSensolrialScale = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 40px 50px auto auto;
    gap: 16px 16px;
    grid-auto-flow: row;
    grid-template-areas:
        '. acceptable acceptable takeAction refuse refuse'
        '. excelent good regular bad critical'
        'reason excelent__reason good__reason regular__reason bad__reason critical__reason'
        'definition excelent__definition good__definition regular__definition bad__definition critical__definition';
    > div {
        border-radius: 3px;
        background: var(--gray-0);
        border: 1px solid var(--gray-300);
        padding: 12px;
    }
    .sensorialScale {
        &--takeAction,
        &--acceptable,
        &--refuse {
            background: var(--gray-700);
            color: var(--gray-0);
            font-family: var(--font-semibold);
            padding: 12px;
            text-transform: capitalize;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            border: none;
        }
        &--takeAction {
            grid-area: takeAction;
        }

        &--acceptable {
            grid-area: acceptable;
        }
        &--refuse {
            grid-area: refuse;
        }

        &--excelent,
        &--good,
        &--regular,
        &--bad,
        &--critical {
            padding: 14px;
            color: var(--gray-0);
            text-transform: uppercase;
            font-family: var(--font-semibold);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
        }
        &--excelent {
            background: ${RATINGS_COLORS[0]};
            grid-area: excelent;
        }

        &--good {
            background: ${RATINGS_COLORS[1]};
            grid-area: good;
        }

        &--regular {
            background: ${RATINGS_COLORS[2]};
            grid-area: regular;
        }

        &--bad {
            background: ${RATINGS_COLORS[3]};
            grid-area: bad;
        }

        &--critical {
            background: ${RATINGS_COLORS[4]};
            grid-area: critical;
        }

        &--reason,
        &--definition {
            display: flex;
            justify-content: center;
            align-items: center;
            background: var(--gray-300);
            border: 1px solid var(--gray-400);
            color: var(--gray-800);
            text-transform: capitalize;
            font-family: var(--font-semibold);
            font-size: 17px;
        }

        &--reason {
            grid-area: reason;
        }

        &--definition {
            grid-area: definition;
        }

        &--excelent__reason {
            grid-area: excelent__reason;
        }

        &--good__reason {
            grid-area: good__reason;
        }

        &--regular__reason {
            grid-area: regular__reason;
        }

        &--bad__reason {
            grid-area: bad__reason;
        }

        &--critical__reason {
            grid-area: critical__reason;
        }

        &--excelent__definition {
            grid-area: excelent__definition;
        }

        &--good__definition {
            grid-area: good__definition;
        }

        &--regular__definition {
            grid-area: regular__definition;
        }

        &--bad__definition {
            grid-area: bad__definition;
        }

        &--critical__definition {
            grid-area: critical__definition;
        }
    }
`
